import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["text", "toggleIcon"]
    static values = {
        fullText: String,
        fixAlignment: { type: Boolean, default: true },
        truncatedHtml: String
    }

    connect() {
        this.expanded = false
        this.checkLineCount()

        this.resizeHandler = this.checkLineCount.bind(this)
        window.addEventListener('resize', this.resizeHandler)
    }

    disconnect() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler)
        }
    }

    toggleExpand(event) {
        event.preventDefault()

        this.expanded = !this.expanded

        if (this.expanded) {
            this.toggleIconTarget.innerHTML = '<i class="material-icons" style="font-size: 16px">keyboard_arrow_up</i>'
            this.textTarget.innerHTML = this.fullTextValue // Show full text
        } else {
            this.toggleIconTarget.innerHTML = '<i class="material-icons" style="font-size: 16px">keyboard_arrow_down</i>'
            this.textTarget.innerHTML = this.truncatedHtmlValue // Show truncated text with link
        }

        this.checkLineCount()
    }

    checkLineCount() {
        if (!this.fixAlignmentValue) {
            return
        }
        if (this.hasMultipleLines(this.textTarget)) {
            this.textTarget.style.textAlign = 'left'
        } else {
            this.textTarget.style.textAlign = 'right'
        }
    }

    hasMultipleLines(element) {
        // Check for BR tags or multiple paragraphs (most reliable)
        const hasBrTags = element.querySelector('br') !== null
        const paragraphs = element.querySelectorAll('p')
        const hasMultipleParagraphs = paragraphs.length > 1
        if (hasBrTags || hasMultipleParagraphs) {
            return true
        }

        // Check if content wraps by measuring text width
        const firstParagraph = paragraphs[0]
        if (firstParagraph) {
            return this.checkTextWrapping(firstParagraph, element)
        }

        return false
    }

    checkTextWrapping(textElement, containerElement) {
        // Create a temporary element to measure text width
        const temp = document.createElement('span')
        temp.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-family: ${getComputedStyle(textElement).fontFamily};
      font-size: ${getComputedStyle(textElement).fontSize};
      font-weight: ${getComputedStyle(textElement).fontWeight};
      letter-spacing: ${getComputedStyle(textElement).letterSpacing};
    `
        temp.textContent = textElement.textContent

        document.body.appendChild(temp)
        const textWidth = temp.offsetWidth
        document.body.removeChild(temp)

        // Get available width (subtract padding)
        const containerStyle = getComputedStyle(containerElement)
        const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0
        const paddingRight = parseFloat(containerStyle.paddingRight) || 0
        const availableWidth = containerElement.clientWidth - paddingLeft - paddingRight

        // If text is wider than available space, it wraps
        return textWidth > availableWidth
    }
}